module.exports = __webpack_public_path__ + "be36d1c2c10009c5b39925a3e9bf23e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/blurred-bg/blurred-bg-2.jpg
// module id = 375
// module chunks = 0